/* eslint-disable import/prefer-default-export */
export const isHexColorValid = hexColor => {
  if (typeof hexColor !== 'string') return false
  const regexForHexColor = /^#([0-9a-f]{3}){1,2}$/i
  return regexForHexColor.test(hexColor)
}
